module.exports = __webpack_public_path__ + "img/aeroland-sass-image-01.f69d1f5c.png";